import { render, staticRenderFns } from "./TagIndexContainer.vue?vue&type=template&id=01babb8a&"
import script from "./TagIndexContainer.vue?vue&type=script&lang=js&"
export * from "./TagIndexContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports